import { Typography } from '@mui/material';
import styled from 'styled-components';

import { BaseColorKeys, PureColorKeys } from '../../theme';

const StudentStateToggleBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

interface StudentStateToggleProps {
  $selected: boolean;
  $color: BaseColorKeys | PureColorKeys;
}

const StudentStateToggle = styled(Typography)<StudentStateToggleProps>`
  && {
    &:hover {
      background-color: ${({ theme, $color }) => theme.palette[$color].light};
    }
    border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
    padding: ${({ theme }) => theme.spacing(0.5, 1.5)};
    color: ${({ theme }) => theme.palette.gray.main};
    font-weight: ${({ $selected }) => ($selected ? 600 : 'none')};
    border-color: ${({ theme, $color }) => theme.palette[$color].dark};
    background-color: ${({ theme, $selected, $color }) => ($selected ? theme.palette[$color].light : 'inherit')};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export { StudentStateToggleBar, StudentStateToggle };
